import React, { useContext, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Formik } from 'formik';
import { useMutation } from '@apollo/client';
import toast from 'react-hot-toast';
import * as yup from 'yup';

import AuthContext from '../../contexts/AuthContext';
import DataState from '../DataState';
import {
  TitleContainer,
  Title,
  Label,
  Input,
  Button,
  FormBody,
  FormField,
} from '../../elements';

import { UPDATE_CURRENT_USER } from './queries';

export const passwordSchema = yup.object({
  password: yup
    .string()
    .min(8, 'Password must have 8 or more characters'),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Passwords must match')
});

const Account = () => {
  const [formSubmitting, setFormSubmitting] = useState(false);

  const { user, refetchData } = useContext(AuthContext);

  const [updateCurrentUser] = useMutation(UPDATE_CURRENT_USER, {
    onCompleted: () => {
      refetchData();
      toast('Account Updated');
      setFormSubmitting(false);
    }
  });

  const handleSubmit = values => {
    setFormSubmitting(true);
    updateCurrentUser({ variables: values });
  };

  return (
    <>
      <Helmet>
        <title>Update Account</title>
      </Helmet>

      <TitleContainer>
        <Title>Update Account</Title>
      </TitleContainer>

      {(formSubmitting || !user) ? <DataState.Loading /> : (
        <Formik
          initialValues={{
            firstName: user.firstName,
            lastName: user.lastName,
            password: '',
            passwordConfirmation: ''
          }}
          validationSchema={passwordSchema}
          onSubmit={handleSubmit}
        >
          {props => (
            <form onSubmit={props.handleSubmit}>
              <FormBody className="gray-input">
                <FormField>
                  <Label>First Name</Label>
                  <Input
                    type="text"
                    name="firstName"
                  />
                </FormField>

                <FormField>
                  <Label>Last Name</Label>
                  <Input
                    type="text"
                    name="lastName"
                  />
                </FormField>

                <FormField>
                  <Label>New Password (leave blank to not change)</Label>
                  <Input
                    type="password"
                    name="password"
                    placeholder="Password"
                  />
                </FormField>

                <FormField>
                  <Label>Confirm New Password</Label>
                  <Input
                    type="password"
                    name="passwordConfirmation"
                    placeholder="Confirm Password"
                  />
                </FormField>
              </FormBody>

              <Button type="submit">
                Update My Account
              </Button>
            </form>
          )}
        </Formik>
      )}
    </>
  );
};

export default Account;
